/**
 * Generated from PostcardNairobi1Layout.fla
 */
export function PostcardNairobi1Layout(this: IPostcardNairobi1Layout) {
	const main = this.main;
	PostcardNairobi1Layout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function PostcardNairobi1Layout_main(this: IPostcardNairobi1Layout_main) {
	const postcard = this.postcard;
	PostcardNairobi1Layout_postcard.call(this.postcard);
	postcard.x = 0;
	postcard.y = 4.7;
	if (postcard.scale) postcard.scale.x = 0.633;
	if (postcard.scale) postcard.scale.y = 0.633;
	if (postcard.onLayout) postcard.onLayout();
	return this;
}
function PostcardNairobi1Layout_postcard(this: IPostcardNairobi1Layout_postcard) {
	const cardTransform = this.cardTransform;
	if (!cardTransform[0] && cardTransform.elementFactory) {
		cardTransform[0] = cardTransform.elementFactory(0,undefined);
	}
	if (cardTransform[0]) {
		PostcardNairobi1Layout_cardTransform1.call(cardTransform[0] as IPostcardNairobi1Layout_cardTransform1);
		cardTransform[0].x = -466.55;
		cardTransform[0].y = 54.3;
		cardTransform[0].width = 724.42;
		cardTransform[0].height = 908.04;
		if (cardTransform[0].onLayout) cardTransform[0].onLayout();
	}
	if (!cardTransform[1] && cardTransform.elementFactory) {
		cardTransform[1] = cardTransform.elementFactory(1,undefined);
	}
	if (cardTransform[1]) {
		PostcardNairobi1Layout_cardTransform2.call(cardTransform[1] as IPostcardNairobi1Layout_cardTransform2);
		cardTransform[1].x = 514.55;
		cardTransform[1].y = 348.05;
		cardTransform[1].width = 561.71;
		cardTransform[1].height = 704.09;
		if (cardTransform[1].onLayout) cardTransform[1].onLayout();
	}
	if (!cardTransform[2] && cardTransform.elementFactory) {
		cardTransform[2] = cardTransform.elementFactory(2,undefined);
	}
	if (cardTransform[2]) {
		PostcardNairobi1Layout_cardTransform3.call(cardTransform[2] as IPostcardNairobi1Layout_cardTransform3);
		cardTransform[2].x = -29.65;
		cardTransform[2].y = -466.55;
		cardTransform[2].width = 486.79;
		cardTransform[2].height = 610.17;
		if (cardTransform[2].onLayout) cardTransform[2].onLayout();
	}
	if (!cardTransform[3] && cardTransform.elementFactory) {
		cardTransform[3] = cardTransform.elementFactory(3,undefined);
	}
	if (cardTransform[3]) {
		PostcardNairobi1Layout_cardTransform4.call(cardTransform[3] as IPostcardNairobi1Layout_cardTransform4);
		cardTransform[3].x = -161.25;
		cardTransform[3].y = 80.1;
		cardTransform[3].width = 697.91;
		cardTransform[3].height = 874.81;
		if (cardTransform[3].onLayout) cardTransform[3].onLayout();
	}
	if (!cardTransform[4] && cardTransform.elementFactory) {
		cardTransform[4] = cardTransform.elementFactory(4,undefined);
	}
	if (cardTransform[4]) {
		PostcardNairobi1Layout_cardTransform5.call(cardTransform[4] as IPostcardNairobi1Layout_cardTransform5);
		cardTransform[4].x = -621.85;
		cardTransform[4].y = -399.45;
		cardTransform[4].width = 499.16;
		cardTransform[4].height = 625.69;
		if (cardTransform[4].onLayout) cardTransform[4].onLayout();
	}
	if (!cardTransform[5] && cardTransform.elementFactory) {
		cardTransform[5] = cardTransform.elementFactory(5,undefined);
	}
	if (cardTransform[5]) {
		PostcardNairobi1Layout_cardTransform6.call(cardTransform[5] as IPostcardNairobi1Layout_cardTransform6);
		cardTransform[5].x = 240.35;
		cardTransform[5].y = 158.75;
		cardTransform[5].width = 604.46;
		cardTransform[5].height = 757.67;
		if (cardTransform[5].onLayout) cardTransform[5].onLayout();
	}
	if (!cardTransform[6] && cardTransform.elementFactory) {
		cardTransform[6] = cardTransform.elementFactory(6,undefined);
	}
	if (cardTransform[6]) {
		PostcardNairobi1Layout_cardTransform7.call(cardTransform[6] as IPostcardNairobi1Layout_cardTransform7);
		cardTransform[6].x = 497.9;
		cardTransform[6].y = -41.05;
		cardTransform[6].width = 1050.10;
		cardTransform[6].height = 1316.27;
		if (cardTransform[6].onLayout) cardTransform[6].onLayout();
	}
	if (!cardTransform[7] && cardTransform.elementFactory) {
		cardTransform[7] = cardTransform.elementFactory(7,undefined);
	}
	if (cardTransform[7]) {
		PostcardNairobi1Layout_cardTransform8.call(cardTransform[7] as IPostcardNairobi1Layout_cardTransform8);
		cardTransform[7].x = -638.75;
		cardTransform[7].y = 69.55;
		cardTransform[7].width = 571.63;
		cardTransform[7].height = 716.52;
		if (cardTransform[7].onLayout) cardTransform[7].onLayout();
	}
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		PostcardNairobi1Layout_pieces3.call(items[0] as IPostcardNairobi1Layout_pieces3);
		items[0].x = -23.85;
		items[0].y = -471.1;
		items[0].width = 386.00;
		items[0].height = 168.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		PostcardNairobi1Layout_outlines3.call(items[1] as IPostcardNairobi1Layout_outlines3);
		items[1].x = -24.2;
		items[1].y = -471.35;
		items[1].width = 385.00;
		items[1].height = 168.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		PostcardNairobi1Layout_pieces5.call(items[2] as IPostcardNairobi1Layout_pieces5);
		items[2].x = -602.95;
		items[2].y = -432.2;
		items[2].width = 337.00;
		items[2].height = 979.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		PostcardNairobi1Layout_outlines5.call(items[3] as IPostcardNairobi1Layout_outlines5);
		items[3].x = -608.6;
		items[3].y = -431.3;
		items[3].width = 312.00;
		items[3].height = 208.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		PostcardNairobi1Layout_pieces7.call(items[4] as IPostcardNairobi1Layout_pieces7);
		items[4].x = 477;
		items[4].y = -53.15;
		items[4].width = 817.00;
		items[4].height = 802.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		PostcardNairobi1Layout_outlines7.call(items[5] as IPostcardNairobi1Layout_outlines7);
		items[5].x = 459.25;
		items[5].y = -45.5;
		items[5].width = 789.00;
		items[5].height = 787.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,undefined);
	}
	if (items[6]) {
		PostcardNairobi1Layout_pieces1.call(items[6] as IPostcardNairobi1Layout_pieces1);
		items[6].x = -500.3;
		items[6].y = 49.95;
		items[6].width = 453.00;
		items[6].height = 645.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		PostcardNairobi1Layout_outlines1.call(items[7] as IPostcardNairobi1Layout_outlines1);
		items[7].x = -499.9;
		items[7].y = 39.25;
		items[7].width = 449.00;
		items[7].height = 625.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,undefined);
	}
	if (items[8]) {
		PostcardNairobi1Layout_pieces6.call(items[8] as IPostcardNairobi1Layout_pieces6);
		items[8].x = 237.9;
		items[8].y = 196.15;
		items[8].width = 482.00;
		items[8].height = 295.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,undefined);
	}
	if (items[9]) {
		PostcardNairobi1Layout_outlines6.call(items[9] as IPostcardNairobi1Layout_outlines6);
		items[9].x = 237.5;
		items[9].y = 194;
		items[9].width = 482.00;
		items[9].height = 295.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,undefined);
	}
	if (items[10]) {
		PostcardNairobi1Layout_decorations2.call(items[10] as IPostcardNairobi1Layout_decorations2);
		items[10].x = 31;
		items[10].y = 425.6;
		items[10].width = 1727.00;
		items[10].height = 452.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[11]) {
		PostcardNairobi1Layout_pieces4.call(items[11] as IPostcardNairobi1Layout_pieces4);
		(items[11] as IPostcardNairobi1Layout_pieces4).dependsOn = 0;
		(items[11] as IPostcardNairobi1Layout_pieces4).outlineGlow = true;
		items[11].x = -199.15;
		items[11].y = 198.8;
		items[11].width = 471.00;
		items[11].height = 712.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,undefined);
	}
	if (items[12]) {
		PostcardNairobi1Layout_outlines4.call(items[12] as IPostcardNairobi1Layout_outlines4);
		items[12].x = -126.35;
		items[12].y = 75.7;
		items[12].width = 451.00;
		items[12].height = 701.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[13]) {
		PostcardNairobi1Layout_pieces2.call(items[13] as IPostcardNairobi1Layout_pieces2);
		(items[13] as IPostcardNairobi1Layout_pieces2).dependsOn = 0;
		(items[13] as IPostcardNairobi1Layout_pieces2).outlineGlow = true;
		items[13].x = 512.65;
		items[13].y = 367.55;
		items[13].width = 400.99;
		items[13].height = 284.99;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,undefined);
	}
	if (items[14]) {
		PostcardNairobi1Layout_outlines2.call(items[14] as IPostcardNairobi1Layout_outlines2);
		items[14].x = 514.75;
		items[14].y = 365.45;
		items[14].width = 384.00;
		items[14].height = 277.00;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,undefined);
	}
	if (items[15]) {
		PostcardNairobi1Layout_decorations1.call(items[15] as IPostcardNairobi1Layout_decorations1);
		items[15].x = 783.1;
		items[15].y = 431.3;
		items[15].width = 296.00;
		items[15].height = 269.00;
		if (items[15].onLayout) items[15].onLayout();
	}
	const shapes = this.shapes;
	if (!shapes[0] && shapes.elementFactory) {
		shapes[0] = shapes.elementFactory(0,undefined);
	}
	if (shapes[0]) {
		shapes[0] = [5.00,0.00];
	}
	if (!shapes[1] && shapes.elementFactory) {
		shapes[1] = shapes.elementFactory(1,undefined);
	}
	if (shapes[1]) {
		shapes[1] = [10.00,0.00];
	}
	if (!shapes[2] && shapes.elementFactory) {
		shapes[2] = shapes.elementFactory(2,undefined);
	}
	if (shapes[2]) {
		shapes[2] = [5.00,0.00];
	}
	if (!shapes[3] && shapes.elementFactory) {
		shapes[3] = shapes.elementFactory(3,undefined);
	}
	if (shapes[3]) {
		shapes[3] = [-207.05,133.70,-167.30,78.30,-80.70,-184.15,-69.80,-246.75,-26.45,-280.45,37.35,-264.80,109.55,-176.90,102.30,-138.40,31.30,-138.40,-44.50,208.35,-43.30,432.20,-202.25,440.65,-363.55,435.80,-364.75,346.75,-355.10,215.55,-305.75,148.10];
	}
	const background = this.background;
	PostcardNairobi1Layout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1790.00;
	background.height = 1325.00;
	if (background.onLayout) background.onLayout();
	const postcardOverlay = this.postcardOverlay;
	PostcardNairobi1Layout_postcardOverlay.call(this.postcardOverlay);
	postcardOverlay.x = 0;
	postcardOverlay.y = 0;
	postcardOverlay.width = 1784.00;
	postcardOverlay.height = 1318.00;
	if (postcardOverlay.onLayout) postcardOverlay.onLayout();
	const postcardMask = this.postcardMask;
	postcardMask.push(11.60,-642.40,878.60,-641.10,869.70,11.90,875.65,626.30,29.70,629.25,-492.65,638.15,-880.20,652.65,-875.55,-47.50,-881.50,-655.95);
	return this;
}
function PostcardNairobi1Layout_background(this: IPostcardNairobi1Layout_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-nairobi-1.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi1Layout_cardTransform6(this: IPostcardNairobi1Layout_cardTransform6) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-1-6.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi1Layout_cardTransform5(this: IPostcardNairobi1Layout_cardTransform5) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-1-5.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi1Layout_cardTransform3(this: IPostcardNairobi1Layout_cardTransform3) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-1-3.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi1Layout_cardTransform2(this: IPostcardNairobi1Layout_cardTransform2) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-1-2.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi1Layout_cardTransform4(this: IPostcardNairobi1Layout_cardTransform4) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-1-4.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi1Layout_cardTransform8(this: IPostcardNairobi1Layout_cardTransform8) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-1-8.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi1Layout_cardTransform7(this: IPostcardNairobi1Layout_cardTransform7) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-1-7.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi1Layout_cardTransform1(this: IPostcardNairobi1Layout_cardTransform1) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-1-1.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi1Layout_pieces3(this: IPostcardNairobi1Layout_pieces3) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-1-3.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi1Layout_outlines3(this: IPostcardNairobi1Layout_outlines3) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-1-3.png", 0.501, 0.500);
	return this;
}
function PostcardNairobi1Layout_pieces5(this: IPostcardNairobi1Layout_pieces5) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-1-5.png", 0.555, 0.126);
	return this;
}
function PostcardNairobi1Layout_outlines5(this: IPostcardNairobi1Layout_outlines5) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-1-5.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi1Layout_pieces7(this: IPostcardNairobi1Layout_pieces7) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-1-7.png", 0.526, 0.500);
	return this;
}
function PostcardNairobi1Layout_outlines7(this: IPostcardNairobi1Layout_outlines7) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-1-7.png", 0.501, 0.501);
	return this;
}
function PostcardNairobi1Layout_pieces1(this: IPostcardNairobi1Layout_pieces1) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-1-1.png", 0.501, 0.501);
	return this;
}
function PostcardNairobi1Layout_outlines1(this: IPostcardNairobi1Layout_outlines1) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-1-1.png", 0.501, 0.501);
	return this;
}
function PostcardNairobi1Layout_pieces6(this: IPostcardNairobi1Layout_pieces6) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-1-6.png", 0.500, 0.502);
	return this;
}
function PostcardNairobi1Layout_outlines6(this: IPostcardNairobi1Layout_outlines6) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-1-6.png", 0.500, 0.502);
	return this;
}
function PostcardNairobi1Layout_decorations2(this: IPostcardNairobi1Layout_decorations2) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-nairobi-1-2.png", 0.521, 0.544);
	return this;
}
function PostcardNairobi1Layout_pieces4(this: IPostcardNairobi1Layout_pieces4) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-1-4.png", 0.367, 0.666);
	return this;
}
function PostcardNairobi1Layout_outlines4(this: IPostcardNairobi1Layout_outlines4) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-1-4.png", 0.501, 0.501);
	return this;
}
function PostcardNairobi1Layout_pieces2(this: IPostcardNairobi1Layout_pieces2) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-1-2.png", 0.501, 0.502);
	return this;
}
function PostcardNairobi1Layout_outlines2(this: IPostcardNairobi1Layout_outlines2) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-1-2.png", 0.500, 0.502);
	return this;
}
function PostcardNairobi1Layout_decorations1(this: IPostcardNairobi1Layout_decorations1) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-nairobi-1-1.png", 0.747, 0.591);
	return this;
}
function PostcardNairobi1Layout_shapes4(this: IPostcardNairobi1Layout_shapes4) {
	return this;
}
function PostcardNairobi1Layout_shapes1(this: IPostcardNairobi1Layout_shapes1) {
	return this;
}
function PostcardNairobi1Layout_shapes2(this: IPostcardNairobi1Layout_shapes2) {
	return this;
}
function PostcardNairobi1Layout_shapes3(this: IPostcardNairobi1Layout_shapes3) {
	return this;
}
function PostcardNairobi1Layout_postcardOverlay(this: IPostcardNairobi1Layout_postcardOverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-border.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi1Layout_postcardMask(this: IPostcardNairobi1Layout_postcardMask) {
	return this;
}
interface IPostcardNairobi1LayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPostcardNairobi1LayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPostcardNairobi1LayoutSprite extends IPostcardNairobi1LayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPostcardNairobi1LayoutText extends IPostcardNairobi1LayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPostcardNairobi1LayoutPolygon extends Array<number> {
}
interface IPostcardNairobi1Layout {
	readonly main: IPostcardNairobi1Layout_main;
}
interface IPostcardNairobi1Layout_main extends IPostcardNairobi1LayoutContainer {
	readonly postcard: IPostcardNairobi1Layout_postcard;
}
interface IPostcardNairobi1Layout_postcard extends IPostcardNairobi1LayoutContainer {
	readonly cardTransform: IPostcardNairobi1LayoutArray<IPostcardNairobi1Layout_cardTransform1|IPostcardNairobi1Layout_cardTransform2|IPostcardNairobi1Layout_cardTransform3|IPostcardNairobi1Layout_cardTransform4|IPostcardNairobi1Layout_cardTransform5|IPostcardNairobi1Layout_cardTransform6|IPostcardNairobi1Layout_cardTransform7|IPostcardNairobi1Layout_cardTransform8>;
	readonly items: IPostcardNairobi1LayoutArray<IPostcardNairobi1Layout_pieces3|IPostcardNairobi1Layout_outlines3|IPostcardNairobi1Layout_pieces5|IPostcardNairobi1Layout_outlines5|IPostcardNairobi1Layout_pieces7|IPostcardNairobi1Layout_outlines7|IPostcardNairobi1Layout_pieces1|IPostcardNairobi1Layout_outlines1|IPostcardNairobi1Layout_pieces6|IPostcardNairobi1Layout_outlines6|IPostcardNairobi1Layout_decorations2|IPostcardNairobi1Layout_pieces4|IPostcardNairobi1Layout_outlines4|IPostcardNairobi1Layout_pieces2|IPostcardNairobi1Layout_outlines2|IPostcardNairobi1Layout_decorations1>;
	readonly shapes: IPostcardNairobi1LayoutArray<IPostcardNairobi1Layout_shapes1|IPostcardNairobi1Layout_shapes2|IPostcardNairobi1Layout_shapes3|IPostcardNairobi1Layout_shapes4>;
	readonly background: IPostcardNairobi1Layout_background;
	readonly postcardOverlay: IPostcardNairobi1Layout_postcardOverlay;
	readonly postcardMask: IPostcardNairobi1Layout_postcardMask;
}
interface IPostcardNairobi1Layout_background extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_cardTransform6 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_cardTransform5 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_cardTransform3 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_cardTransform2 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_cardTransform4 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_cardTransform8 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_cardTransform7 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_cardTransform1 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_pieces3 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_outlines3 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_pieces5 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_outlines5 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_pieces7 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_outlines7 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_pieces1 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_outlines1 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_pieces6 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_outlines6 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_decorations2 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_pieces4 extends IPostcardNairobi1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardNairobi1Layout_outlines4 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_pieces2 extends IPostcardNairobi1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardNairobi1Layout_outlines2 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_decorations1 extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_shapes4 extends IPostcardNairobi1LayoutPolygon {
}
interface IPostcardNairobi1Layout_shapes1 extends IPostcardNairobi1LayoutPolygon {
}
interface IPostcardNairobi1Layout_shapes2 extends IPostcardNairobi1LayoutPolygon {
}
interface IPostcardNairobi1Layout_shapes3 extends IPostcardNairobi1LayoutPolygon {
}
interface IPostcardNairobi1Layout_postcardOverlay extends IPostcardNairobi1LayoutSprite {
}
interface IPostcardNairobi1Layout_postcardMask extends IPostcardNairobi1LayoutPolygon {
}
